module.exports = "textarea {\r\n  height: 200px;\r\n  resize: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/send-email-form/send-email-form.component.css
// module id = ./src/app/shared/components/send-email-form/send-email-form.component.css
// module chunks = main